module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className || 'mt-2'
  }, [_c('v-btn', {
    attrs: {
      "block": !_vm.noBlock,
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.download(_vm.url)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.label || 'Download Video') + "\n    "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("mdi-download")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70882e1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/custom/BtnDownload.vue
// module id = 2185
// module chunks = 0